// Get All Businesses
export const GET_ALL_BUSINESSES_REQUEST = "GET_ALL_BUSINESSES_REQUEST";
export const GET_ALL_BUSINESSES_SUCCESS = "GET_ALL_BUSINESSES_SUCCESS";
export const GET_ALL_BUSINESSES_FAIL = "GET_ALL_BUSINESSES_FAIL";

// Add Business
export const ADD_BUSINESS_REQUEST = "ADD_BUSINESS_REQUEST";
export const ADD_BUSINESS_SUCCESS = "ADD_BUSINESS_SUCCESS";
export const ADD_BUSINESS_FAIL = "ADD_BUSINESS_FAIL";

// Business Log Actions
export const GET_BUSINESS_LOG_REQUEST = "GET_BUSINESS_LOG_REQUEST";
export const GET_BUSINESS_LOG_SUCCESS = "GET_BUSINESS_LOG_SUCCESS";
export const GET_BUSINESS_LOG_FAIL = "GET_BUSINESS_LOG_FAIL";

export const ADD_BUSINESS_LOG_REQUEST = "ADD_BUSINESS_LOG_REQUEST";
export const ADD_BUSINESS_LOG_SUCCESS = "ADD_BUSINESS_LOG_SUCCESS";
export const ADD_BUSINESS_LOG_FAIL = "ADD_BUSINESS_LOG_FAIL";

export const DELETE_BUSINESS_LOG_REQUEST = "DELETE_BUSINESS_LOG_REQUEST";
export const DELETE_BUSINESS_LOG_SUCCESS = "DELETE_BUSINESS_LOG_SUCCESS";
export const DELETE_BUSINESS_LOG_FAIL = "DELETE_BUSINESS_LOG_FAIL";